<style lang="scss">
  .modal {
    font-family: 'Open Sans';
    font-style: normal;
    width: 425px;
    background-color: white;
    
    &-header {
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
      color: #1C2B39;
    }

    &-header-2 {
      font-weight: 600;
      font-size: 21px;
      line-height: 29px;
      color: #000000;
    }

    &-text {
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: #525252;
    }
  }
</style>


<template>
  <v-dialog
    @click:outside="!persistent ? $modals.close() : true"
    v-model="hasActive"
    :persistent="persistent"
    width="425px"
  >
    <component
      :is="modals[value]"
      v-bind="modal"
      class="modal modal__body pa-0"
      @close="$modals.close()"
    />
  </v-dialog>
</template>

<script>
import SendRequest from "./modals/SendRequest.vue";
import ApplicationPending from "./modals/ApplicationPending";
import TimeOut from "./modals/TimeOut";
import Error from "./modals/Error";
import Denial from "./modals/Denial";
import AnotherChoise from "./modals/AnotherChoise";
import Approve from "./modals/Approve";
import ContinueToFill from "./modals/ContinueToFill";
import FoundAccount from "./modals/FoundAccount";
import Link from "./modals/Link";


let modals = {
  SendRequest,
  ApplicationPending,
  TimeOut,
  Error,
  Denial,
  AnotherChoise,
  Approve,
  ContinueToFill,
  FoundAccount,
  Link
};

export default {
  props: {
    value: {
      type: String,
      default: 'нет'
    },
  },
  computed: {
    modal() {
      return this.$root.modals || {};
    },

    persistent() {
      return this.modal.settings?.persistent;
    },

    hasActive() {
      return this.$root.modals.hasActive();
    }
  },
  data: () => ({
    // SolutionExpectation
    modals,
  })
}
</script>
